module.exports = __webpack_public_path__ + "static/media/img_section03_finding03.bb5255ea.png";